import { EQUITY_INVESTMENT_ACCOUNT } from 'srcAlias/client/enums/productDescriptionCode';
import { EQUITY_INVESTMENT_ACCOUNT_CATEGORY } from 'srcAlias/client/enums/productCategory';
import {
  modifyUrl,
  modifyWealthDashboardUrl,
  getUrlParametersList,
} from 'srcAlias/client/utils/urlParameters';
import { clickContinue } from 'srcAlias/client/utils/clickContinue';

export const redirectionToCKA = (values, event, pageName, queryParams) => {
  if (
    (pageName === 'products' && (values.markets.HK || values.markets.US)) ||
    pageName === 'accept'
  ) {
    const url =
      pageName === 'products'
        ? modifyUrl(
            queryParams,
            `${EQUITY_INVESTMENT_ACCOUNT}_${EQUITY_INVESTMENT_ACCOUNT_CATEGORY}`,
            values.markets.HK,
            values.markets.US
          )
        : modifyWealthDashboardUrl(
            queryParams,
            values.marketsAcceptPageCheckbox.HK,
            values.marketsAcceptPageCheckbox.US
          );
    clickContinue(pageName, url);
    event.preventDefault();
    var form = document.createElement('form');
    form.setAttribute('method', 'get');
    form.setAttribute('action', url);
    var input;
    getUrlParametersList(url).forEach(function (item) {
      input = document.createElement('input');
      input.setAttribute('type', 'hidden');
      input.setAttribute('name', item.name);
      input.setAttribute('value', item.value);
      form.appendChild(input);
    });
    document.getElementsByTagName('body')[0].appendChild(form);
    form.submit();
  }
};
